"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestDetailedStatistics = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const DETAILED_STATISTICS_QUERY = (0, graphql_tag_1.default) `
  query DetailedStats($shiftId: ID!) {
    shift(id: $shiftId) {
      stats {
        date
        totalMinutes
        workMinutes
        overTimeTotalMinutes
        overTimeOrderedMinutes
        overTimeAgreedMinutes
        overTimePaidMinutes
        overTimeUnpaidMinutes
        overTimePaidTOILMinutes
        standByMinutes
        standByActivityMinutes
        nightMinutes
        workDayMinutes
        weekEndMinutes
        saturdayMinutes
        sundayMinutes
        holidayMinutes
        positions {
          id
          minutes
        }
        customAttributes {
          minutes
          id
        }
      }
    }
  }
`;
const requestDetailedStatistics = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(DETAILED_STATISTICS_QUERY, { variables });
    (0, error_handler_1.processErrors)(errors);
    return data?.shift.stats;
};
exports.requestDetailedStatistics = requestDetailedStatistics;
